export default "__VITE_ASSET__d_1VCf9u__"